import script from "./BottomMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomMenu.vue?vue&type=script&setup=true&lang=js"

import "./BottomMenu.vue?vue&type=style&index=0&id=7315349d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7315349d"]])

export default __exports__